/** Canais de envio das notificações de prazo de adesão aos institutos. */
export enum CanalNotificacao {
  Email = 'Email',
  PortalParticipante = 'PortalParticipante',
  Sms = 'Sms',
}
